import api from '../../api/index';
import config from '../../../static/config.json';

const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
    // 专业买家
    getMajorList({ rootState, commit }, id) { // 获取专业买家 展会id
        return new Promise((resolve, reject) => {
            api.get(`${config.https.api}/api/v1/member/getmemberpage?exhibitionId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }else{
                    resolve(false);
                }
            }).catch((err) => {
                resolve(false);
                console.log(err);
            });
        });
    },
    //最近新增
    getAddedList({ rootState, commit }, id) { // 获取最近新增 展会id
        return new Promise((resolve, reject) => {
            api.get(`${config.https.api}/api/v1/member/getmembernewpage?exhibitionId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }else{
                    resolve(false);
                }
            }).catch((err) => {
                resolve(false);
                console.log(err);
            });
        });
    },
    //详情页
    getMemberInfo({ rootState, commit }, id) { // 获取人脉详情 inMemberId
        return new Promise((resolve, reject) => {
            api.get(`${config.https.api}/api/v1/member/getmemberinfo?inMemberId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }else{
                    resolve(false);
                }
            }).catch((err) => {
                resolve(false);
                console.log(err);
            });
        });
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
} 